import { Component } from '@angular/core';
import { COLORS } from '@app/member-response-portal/model/constants';
import { EnterpriseYesNoUToggleComponent, ToggleOption, YESNOU_NO, YESNOU_U, YESNOU_YES } from '@rawlings/enterprise-form';

@Component({
  selector: 'machinify-enterprise-yes-no',
  templateUrl: './machinify-enterprise-yes-no.component.html',
  styleUrls: ['./machinify-enterprise-yes-no.component.scss']
})
export class MachinifyEnterpriseYesNoComponent extends EnterpriseYesNoUToggleComponent {

  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  //#endregion Public Variables

  //#region Private Variables
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  public ngAfterViewInit(): void {
    const yesToggle: ToggleOption = new ToggleOption(YESNOU_YES, COLORS.machinify_green, COLORS.machinify_black);
    const noToggle: ToggleOption = new ToggleOption(YESNOU_NO, COLORS.machinify_red, COLORS.machinify_off_white);
    const uToggle: ToggleOption = new ToggleOption(YESNOU_U, COLORS.machinify_red, COLORS.machinify_off_white);

    this.ToggleOptions = [yesToggle, noToggle];
    if (this.ShowButtonU) {
        this.ToggleOptions.splice(1, 0, uToggle);
    }
  }
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods
  //#endregion Public Methods

  //#region Private Methods
  //#endregion Private Methods

}
